<template>
  <div>
    <v-list-item-title avatar height="24" class="" style="margin-top: -20px">
      <v-list-item-title color="white">
        <v-img height="12" contain />
      </v-list-item-title>
      <v-list-item class="title  blue-grey--text">
        <v-list-item-avatar class="mx-n2">
          <logo></logo>
        </v-list-item-avatar>
        <v-list-item>
          <!--                        <v-btn text icon @click.stop="mini = !mini" class="mx-n4"><v-icon dark>mdi-dots-vertical</v-icon></v-btn>-->
          <v-list-item-title class="mx-4 blue-grey--text"
            >Kyami Pay</v-list-item-title
          >
        </v-list-item>
      </v-list-item>
    </v-list-item-title>
  </div>
</template>

<script>
import Logo from "../../logo/Logo";
export default {
  name: "AssetDrawer",
  components: { Logo }
};
</script>

<style scoped></style>
